import React, { useEffect, useLayoutEffect, useState } from "react";
import { CONSTANTS } from "../../../../constants/callcentral.constants";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import AddDeletePopup from "../StatusBoardAddDeletePopup/StatusBoardAddDeletePopup";
import classNames from "classnames/bind";

import "./SupportStaff.scss";
import SBoardProviderModal from "../StatusBoardTable/components/ExpandedCard/components/SBoardProvider/SBoardProviderModal/SBoardProviderModal";
import { statusBoardService } from "../../StatusBoard.service";
import { IonAlert, IonIcon, IonPopover } from "@ionic/react";
import { utilService } from "../../../../services";
import { useToast } from "@agney/ir-toast";
import Sms from "../../../../components/Shared/Sms/sms";
import _ from "lodash";
import { statusBoardSocketService } from "../../StatusBoardSocketService";
import { chatbubbleEllipsesOutline } from "ionicons/icons";
import { useHistory } from "react-router";
import { smsService } from "../../../../components/Shared/Sms/Sms.service";
import { useTranslation } from "react-i18next";

export const SupportStaffProviderContext = React.createContext({
  updateProviderList: (params: any) => {},
  fromComponent: "",
  popUptype: "1",
  SelectedSupportStaffDetails: {
    common_provider: {},
    guid: "",
    id: null,
    name: "",
    site: null,
    specialisation: null,
  },
});
interface SupportStaffProps {
  statusBoardData: any;
  updateTableData: () => void;
  statusBoardId: any;
}

const SupportStaff: React.FC<SupportStaffProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  const [showPopup, setAddDeletePopup] = useState(false);
  const [supportStaffList, setSupportStaffList] = useState(
    props.statusBoardData[0]?.commonProvider
      ? props.statusBoardData[0]?.commonProvider
      : []
  );
  const rolePermissionData = rolePermissionsService.getRolePermissionsDetails();
  const [showProviderCard, setShowProviderCard] = useState(false); //hide/show modal
  const [modelType, setModelType]: any = useState();
  const [selectedDetails, setSelectedDetails]: any = useState();
  const [selectedDetailIndex, setSelectedDetailIndex]: any = useState();
  const [showAlert, setShowAlert] = useState(false);
  const [displayedButtonList, setDisplayedButtonList] = useState<any>([]);
  const [hiddenButtonList, setHiddenButtonList] = useState([]);
  const [isMoreRequired, setIsMoreRequired] = useState(false);
  const Toast = useToast();
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  useLayoutEffect(() => {
    const subscription = statusBoardService.sbCareTeamStaffUpdated.subscribe((res: any) => {
      if (res && res.data) {
        switch (res.socketType) {
          case CONSTANTS.SOCKET_TYPE.SUPPORT_STAFF_LIST:
            setSupportStaffList(res.data);
            setDisplayedButtonList(res.data);
            setHiddenButtonList([]);
            setTimeout(() => {
              setIsMoreRequired(false);
              setDataList(res.data);
            }, 500);
            break;
          case CONSTANTS.SOCKET_TYPE.SUPPORT_STAFF_UPDATE:
            const currentStaffList = statusBoardService.currentSupportStaffList
              ? statusBoardService.currentSupportStaffList
              : [];
            if (currentStaffList && currentStaffList.length) {
              currentStaffList[res.objectIndex] = res.data;
              setSupportStaffList(currentStaffList);
              setDisplayedButtonList(currentStaffList);
              statusBoardService.currentSupportStaffList = currentStaffList;
              setHiddenButtonList([]);
              setShowPopover({ showPopover: false, event: undefined });
              setTimeout(() => {
                setIsMoreRequired(false);
                setDataList(currentStaffList);
              }, 500);
            }
        }
      }
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  const refreshData = (data: any) => {
    if (data) {
      setSupportStaffList(data);
      statusBoardService.currentSupportStaffList = data;
      setDisplayedButtonList(data);
      setHiddenButtonList([]);
      setTimeout(() => {
        setIsMoreRequired(false);
        setDataList(data);
      }, 500);
    }
    setAddDeletePopup(false);
    setShowPopover({ showPopover: false, event: undefined });
  };
  const showAddDeletePopup = () => {
    setAddDeletePopup(true);
  };

  useEffect(() => {
    if (props.statusBoardData && props.statusBoardData.length !== 0) {
      const currentList = [...displayedButtonList, ...hiddenButtonList];
      const incomingList = props.statusBoardData[0]?.commonProvider
        ? props.statusBoardData[0]?.commonProvider
        : [];
      if (!_.isEqual(currentList, incomingList)) {
        updateCareTeamList(props.statusBoardData);
      }
    }
  }, [props.statusBoardData]);

  const updateCareTeamList = (statusBoardData: any) => {
    setSupportStaffList(
      statusBoardData[0]?.commonProvider
        ? statusBoardData[0]?.commonProvider
        : []
    );
    statusBoardService.currentSupportStaffList = statusBoardData[0]
      ?.commonProvider
      ? statusBoardData[0]?.commonProvider
      : [];
    setDisplayedButtonList(
      statusBoardData[0]?.commonProvider
        ? statusBoardData[0]?.commonProvider
        : []
    );
    setTimeout(() => {
      setIsMoreRequired(false);
      setDataList(
        statusBoardData[0]?.commonProvider
          ? statusBoardData[0]?.commonProvider
          : []
      );
    }, 500);
  };

  const setDataList = (commonProviderList: any) => {
    const cardPadding = 0;
    const buttonRow = document.getElementById("dataRow");
    if (buttonRow && buttonRow?.children && buttonRow?.children.length > 0) {
      const dataSet = utilService.updateDisplayButtonList(
        buttonRow,
        _.cloneDeep(commonProviderList),
        cardPadding,
        CONSTANTS.STATUS_BOARD_ROWTYPE.COMMON_PROVIDER
      );
      const displayedButtonLists =
        !utilService.isEmpty(dataSet) && dataSet.displayedButtonList?.length
          ? dataSet.displayedButtonList
          : [];
      if (displayedButtonLists && displayedButtonLists.length) {
        setDisplayedButtonList(displayedButtonLists);
      }
      const hiddenButtonLists =
        dataSet && dataSet.hiddenButtonList ? dataSet.hiddenButtonList : [];
      if (hiddenButtonLists && hiddenButtonLists.length) {
        setHiddenButtonList(hiddenButtonLists);
      }
      const isMoreRequire =
        dataSet && dataSet.isMoreRequired ? dataSet.isMoreRequired : false;
      setIsMoreRequired(isMoreRequire);
    }
  };

  const displayProviderCard = (
    type: String,
    selectedItem: any,
    index: number
  ) => {
    setSelectedDetailIndex(index);
    setShowProviderCard(true);
    setModelType(type);
    setSelectedDetails(selectedItem);
    statusBoardService.selectedProviderPoupType =
      CONSTANTS.PROVIDER_POPUPTYPE.SUPPORT_STAFF;
  };

  const setUpdatedProviderList = (result: any) => {
    statusBoardService.selectedProviderPoupType = "";
    if (result && result.length) {
      const index = utilService.findObjectIndex(
        supportStaffList,
        "id",
        result[0].id
      );
      supportStaffList[index] = result[0];

      // SOCKET CONNECTION
      const socketParams = {
        data: result[0],
        socketType: CONSTANTS.SOCKET_TYPE.SUPPORT_STAFF_UPDATE,
        listType: "displayed",
        objectIndex: index,
      };
      statusBoardSocketService.sendSbSocketParams(socketParams);

      statusBoardService.currentSupportStaffList = supportStaffList;
      setDisplayedButtonList(supportStaffList);
      setHiddenButtonList([]);
      setShowPopover({ showPopover: false, event: undefined });
      setTimeout(() => {
        setIsMoreRequired(false);
        setDataList(supportStaffList);
      }, 500);
    }
    setShowProviderCard(false);
  };
  const closeSbProviderModal = () => {
    statusBoardService.selectedProviderPoupType = "";
    setShowProviderCard(false);
  };

  const removeSupportStaff = (selectedItem: any) => {
    setSelectedDetails(selectedItem);
    setShowAlert(true);
  };

  const proceedRemove = async () => {
    const params = {
      site_id: statusBoardService.statusBoardData
        ? statusBoardService.statusBoardData[0].site?.siteId
        : null,
      cp_id: selectedDetails.id,
      status_board: statusBoardService.statusBoardId
        ? statusBoardService.statusBoardId
        : null,
      reg_code: utilService.getNetwork(),
    };
    const respResult: any = await statusBoardService.deleteSupportStaff(params);
    if (respResult.isSuccess) {
      setDisplayedButtonList(respResult.result);
      setSupportStaffList(respResult.result);
      statusBoardService.currentSupportStaffList = respResult.result;
      setHiddenButtonList([]);
      setShowPopover({ showPopover: false, event: undefined });
      setTimeout(() => {
        setIsMoreRequired(false);
        setDataList(respResult.result);
      }, 500);
      Toast.success(respResult.message);
    } else {
    }
  };

    const history = useHistory();
  
    async function fetchDoctorInfo(params: any) {
      const respDoctorListResult: any = await smsService.getDoctorInformation(
        params
      );
      if (respDoctorListResult.isSuccess) {
        return respDoctorListResult.result;
        // if (respDoctorListResult.result) {
        //   checkSecondaryNumberExists(respDoctorListResult.result.userData);
        // }
      } else {
        console.log("error");
        smsService.handleErrorResponse();
      }
    }

    const handleSendMessage = async (data:any) => {
      const paramsDoctorInfo = {
        guid: data?.common_provider?.guid,
        reg_code: utilService.getNetwork(),
      };
      const result:any = await fetchDoctorInfo(paramsDoctorInfo);
      result.userData.profilePic = result?.userData?.image
      history.push({
        pathname: "/client/messages",
        state: {
          selectedDoctorData: [result?.userData],
          mediaAction: CONSTANTS.MEDIA_ACTIONS.SEND,
          isFullscreen: true,
          // pid:props?.bedData?.details?.pid,
          // unit_id:props?.unitId,
        },
      });
      console.log("test sb displayedButtonList",data)
    }

  
  return (
    <div className="supportStaff-container">
      <div className="support-staff-list-container" id="buttonRows">
        <div className="list-container-width" id="dataRow">
          <div className="support-staff-card-wrapper">
            {displayedButtonList && displayedButtonList.length > 0 ? (
              displayedButtonList.map((item: any, index: number) => {
                return (
                  <div className="support-staff-card" key={index}>
                    <div className="detail-wrapper">
                      <div className="item-role">{item.name}</div>
                      <div className="item-name">
                        {item.common_provider?.name}
                      </div>
                    </div>
                    <div className="icon-wrapper">
                      <div
                        className={classNames({
                          "icon-div": true,
                          "disable-buton":
                            !item?.common_provider?.guid ||
                            !rolePermissionData?.addSupportStaff,
                        })}
                        style={{color:"#098689",fontSize:"1.25rem"}}
                        onClick={()=>handleSendMessage(item)}
                      >
                        {/* <Sms
                          selectedDoctorGuid={item?.common_provider?.guid}
                          callerComponent="statusBoardPage"
                        ></Sms> */}
                        <IonIcon icon={chatbubbleEllipsesOutline} />
                      </div>
                      <div
                        className={classNames({
                          "icon-div": true,
                          "icon-edit": true,
                          "disable-buton":
                            !rolePermissionData?.editSupportStaff,
                        })}

                        onClick={() =>
                          displayProviderCard(
                            CONSTANTS.PROVIDER_POPUPTYPE.PROVIDER,
                            item,
                            index
                          )
                        }
                      ></div>
                      <div
                        className={classNames({
                          "icon-div": true,
                          "icon-close": true,
                          "disable-buton": !rolePermissionData?.addSupportStaff,
                        })}
                        onClick={() => removeSupportStaff(item)}
                      ></div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div
                onClick={showAddDeletePopup}
                className={classNames({
                  "no-list-btn": true,
                  "disable-buton": !rolePermissionData?.addSupportStaff,
                })}
              >
                <span
                  className={classNames({
                    "icon-add": true,
                    " controller": true,
                    "mr-2": true,
                  })}
                ></span>
                <span className="no-data-text"> {t("newSupportStaff")}</span>
              </div>
            )}
          </div>
        </div>

        <div className="support-staff-controller-div">
          {isMoreRequired && (
            <div
              className="icon-menu controller"
              onClick={(e: any) => {
                e.persist();
                setShowPopover({ showPopover: true, event: e });
              }}
            ></div>
          )}
          {displayedButtonList && displayedButtonList.length > 0 && (
            <div
              className={classNames({
                "icon-add": true,
                controller: true,
                "disable-buton": !rolePermissionData?.addSupportStaff,
              })}
              onClick={showAddDeletePopup}
            ></div>
          )}
        </div>
      </div>
      {showPopup && (
        <AddDeletePopup
          careTeamList={[...displayedButtonList, ...hiddenButtonList]}
          showModal={showPopup}
          popUpType={CONSTANTS.STATUS_BOARD_ROWTYPE.COMMON_PROVIDER}
          statusBoardId={props.statusBoardId}
          onCancel={refreshData}
        ></AddDeletePopup>
      )}
      <div>
        <SupportStaffProviderContext.Provider
          value={{
            updateProviderList: (result: any) => setUpdatedProviderList(result),
            fromComponent: CONSTANTS.COMPONENTS.STATUS_BOARD,
            popUptype: modelType,
            SelectedSupportStaffDetails: selectedDetails,
          }}
        >
          <SBoardProviderModal
            showModal={showProviderCard}
            onCancel={() => {
              closeSbProviderModal();
            }}
          />
        </SupportStaffProviderContext.Provider>
      </div>
      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setShowAlert(false)}
        cssClass=""
        header={t("confirmation")}
        message={CONSTANTS.MESSAGES.SUPPORT_STAFF_CONFIRMATION}
        buttons={[
          {
            text: t("no"),
            role: "cancel",
            cssClass: "secondary",
            handler: () => {
              setShowAlert(false);
            },
          },
          {
            text: t("yes"),
            handler: () => {
              proceedRemove();
            },
          },
        ]}
      />
      <IonPopover
        className="popover-list-support-staff-cont"
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() =>
          setShowPopover({ showPopover: false, event: undefined })
        }
      >
        <div className="support-staff-card-wrapper">
          {hiddenButtonList && hiddenButtonList.length > 0
            ? hiddenButtonList.map((item: any, index: number) => {
                return (
                  <div className="support-staff-card" key={index}>
                    <div className="detail-wrapper">
                      <div className="item-role">{item.name}</div>
                      <div className="item-name">
                        {item.common_provider?.name}
                      </div>
                    </div>
                    <div className="icon-wrapper">
                      <div
                        className={classNames({
                          "icon-div": true,
                          "disable-buton": !item?.common_provider?.guid,
                        })}
                      >
                        <Sms
                          selectedDoctorGuid={item?.common_provider?.guid}
                          callerComponent="statusBoardPage"
                        ></Sms>
                      </div>
                      <div
                        className={classNames({
                          "icon-div": true,
                          "icon-edit": true,
                          "disable-buton":
                            !rolePermissionData?.editSupportStaff,
                        })}
                        onClick={() =>
                          displayProviderCard(
                            CONSTANTS.PROVIDER_POPUPTYPE.PROVIDER,
                            item,
                            index
                          )
                        }
                      ></div>
                      <div
                        className="icon-div icon-close"
                        onClick={() => removeSupportStaff(item)}
                      ></div>
                    </div>
                  </div>
                );
              })
            : ""}
        </div>
      </IonPopover>
    </div>
  );
};

export default SupportStaff;
